module.exports = __webpack_public_path__ + "img/175-Bleu Atlantique.jpg";